var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-input",
    _vm._b(
      {
        on: { input: _vm.onPendingValueChanged },
        model: {
          value: _vm.innerValue,
          callback: function ($$v) {
            _vm.innerValue = $$v
          },
          expression: "innerValue",
        },
      },
      "el-input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }